export default __webpack_public_path__ + "static/media/Deposit.b1b34a90.svg";